import { Booking } from '../../entities/booking';
import { Component, Input } from '@angular/core';
import { NavController } from 'ionic-angular';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';
import { ViewBookingPage } from '../../pages/bookings/my-bookings/view-booking/view-booking';

@Component({
    selector: 'item-group',
    templateUrl: 'item-group.html'
})
export class ItemGroupComponent {

    @Input('items') items: Booking[];
    @Input('strapline') strapline: string;
    @Input('title') title: string;
    @Input('emptyMessage') emptyMessage: string;

    constructor(
        private navCtrl: NavController,
        private spinner: SpinnerDialog,
    ) {
    }

    async viewBooking(item: Booking) {
        this.spinner.show();
        this.navCtrl.push(ViewBookingPage, {booking: item});
        this.spinner.hide();
    }

    showPinkSuccessIcon(item: Booking): boolean {
        return item.status === 'Shipped';
    }

    showSuccessIcon(item: Booking): boolean {
        return item.status === 'Confirmed';
    }

    showWarningIcon(item: Booking): boolean {
        return item.status === 'Pending' || item.status === 'Standby';
    }

    showDangerIcon(item: Booking): boolean {
        return item.status === 'Cancelled';
    }

    get noItems(): boolean {
        return this.items.length === 0;
    }

}



// WEBPACK FOOTER //
// ./src/components/item-group/item-group.ts